module.exports = __webpack_public_path__ + "static/fpk2-a8ecce3ee932bbe4e38979c2a6d60e8b.png";